/**
 * Сменился ли состав номенклатуры в строках товаров.
 *
 * Нужна, потому что общий сброс расчёта завязан на флаг «временное изменение»:
 * пока строка правится, расчёт нарочно не прячут, иначе он мигал бы на каждую
 * цифру в поле количества. Для НАЗВАНИЯ такая отсрочка вредна — товар уже
 * другой, и показанный расчёт относится к прежнему (20.10.2026, Роман: выбрал
 * второй сорт, сменил на первый, а расчёт остался от второго).
 *
 * Сравниваются только названия и их порядок. Количество, цена и служебные поля
 * сюда не входят: их изменения обрабатывает прежний механизм.
 */

/** Названия строк в том же порядке, в каком они на экране. */
export const productNames = (products) => (Array.isArray(products) ? products : [])
  .map((product) => String(product?.name ?? '').trim());

/**
 * @param {Array} predydushchie — названия с прошлой проверки
 * @param {Array} tekushchie   — названия сейчас
 * @returns {boolean} true, если набор или порядок названий изменился
 */
export const productNamesChanged = (predydushchie, tekushchie) => {
  const a = Array.isArray(predydushchie) ? predydushchie : [];
  const b = Array.isArray(tekushchie) ? tekushchie : [];
  if (a.length !== b.length) {
    return true;
  }
  return a.some((name, index) => name !== b[index]);
};
